import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="payment-cancel">
      <div className="border border-stone-200 bg-white p-8">
        <div className="w-16 h-16 bg-red-100 text-red-600 flex items-center justify-center mx-auto mb-4">
          <XCircle size={40} weight="fill" />
        </div>
        <h1 className="font-display text-3xl font-black tracking-tighter mb-2">Ödeme iptal edildi</h1>
        <p className="text-stone-500 mb-6 text-sm">İşleminiz iptal edildi. İstediğiniz zaman tekrar deneyebilirsiniz.</p>
        <Link to="/panelim" className="inline-block bg-stone-950 text-white px-6 py-3 font-bold hover:bg-stone-800 transition-colors">
          Panele Dön
        </Link>
      </div>
    </div>
  );
}
